import { Injectable } from "@angular/core";

type ResizeObserverCallback = () => void;

@Injectable({
    providedIn: "root",
})
export class ResizeObserverService {
    private readonly observer: ResizeObserver;
    private readonly observedElements = new Map<
        Element,
        ResizeObserverCallback
    >();

    constructor() {
        this.observer = new ResizeObserver((elements) => {
            for (const element of elements) {
                const callback = this.observedElements.get(element.target);
                if (callback) {
                    callback();
                }
            }
        });
    }

    public observe(element: Element, callback: ResizeObserverCallback): void {
        if (!this.observedElements.has(element)) {
            this.observedElements.set(element, callback);
            this.observer.observe(element);
        }
    }

    public unobserve(element: Element): void {
        if (!this.observedElements.has(element)) return;

        this.observer.unobserve(element);
        this.observedElements.delete(element);
    }

    public teardown(): void {
        this.observedElements.clear();
        this.observer.disconnect();
    }
}
